module.exports = __webpack_public_path__ + "media/images/icons/country_flags/fk-0d7b8bda0baf2ed4f379c8a54683e909.svg";